import { render, staticRenderFns } from "./Kuratorium.vue?vue&type=template&id=663ad700"
import script from "./Kuratorium.vue?vue&type=script&lang=js"
export * from "./Kuratorium.vue?vue&type=script&lang=js"
import style0 from "./Kuratorium.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports